import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Header from "./components/header/Header.jsx";
import Footer from "./components/footer/Footer.jsx";
import PageRoutes from './routes/routes.js';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Header />
      <PageRoutes />
      <Footer />
    </Router>
  </React.StrictMode>
);